import { styled } from '@mui/material/styles';

export const MessageArea = styled('div')`
  position: relative;
  width: fit-content;
  white-space: pre-line;
`;
